import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams, useSearchParams, useLocation, Navigate } from "react-router-dom";
import { ProductContext } from '../../context/ProductContext.js';
import { CategoryContext } from '../../context/CategoryContext.js';
import Sidebar from '../../components/Sidebar.js';
import "./CategoriesProduct.css";
import { FaSearch } from 'react-icons/fa';
import _ from 'lodash';
import { FavoriteContext } from '../../context/FavoriteContext.js';
import { useImage } from "../../context/ImageContext.js";
import Loader from '../../components/Loader.js';
import { Helmet } from "react-helmet-async";
import ProductCard from '../../components/product/ProductCard.js';

const CategoriesProduct = () => {

    const { getImageUrl } = useImage();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || "newest";
    const { state, fetchCategoryProducts, dispatch, handleMaxPriceChange, handleMinPriceChange, filterByPrice, } = useContext(ProductContext);
    const { products, loading, error, filteredProducts,minPrice, maxPrice, sortOrder } = state;
    const [hasMore, setHasMore] = useState(true);
    const { favorites, addToFavorite, removeFavorite, loadFavorites } = useContext(FavoriteContext);
    const navigate = useNavigate();
    const [shouldRedirectTo404, setShouldRedirectTo404] = useState(false);
    const { state: categoryState } = useContext(CategoryContext);
    const { categories } = categoryState;
    
    // Kategori bilgisini bul
    const currentCategory = categories.find(cat => cat.sef === id || cat.id === parseInt(id));
    
    // Meta etiketleri için dinamik içerik
    const getCategoryTitle = () => {
        if (currentCategory) {
            const productCount = filteredProducts.length;
            if (productCount > 0) {
                return `${currentCategory.baslik} (${productCount} Ürün) | BiKuyum`;
            }
            return `${currentCategory.baslik} | BiKuyum`;
        }
        return 'Kategoriler | BiKuyum';
    };
    
    const getCategoryDescription = () => {
        if (currentCategory && filteredProducts.length > 0) {
            const productCount = filteredProducts.length;
            
            let description = `${currentCategory.google_baslik} kategorisinde ${currentCategory.baslik}`;
            
            
            description += ` BiKuyum güvencesiyle ${currentCategory.baslik.toLowerCase()} satışı yapılır. İkinci el altın ve mücevher ürünleri güvenilir şekilde satılır.`;
            
            return description;
        } else if (currentCategory) {
            return `${currentCategory.baslik} kategorisinde ikinci el altın. BiKuyum güvencesiyle güvenilir şekilde ${currentCategory.baslik.toLowerCase()} satışı yapılır.`;
        }
        return 'BiKuyum kategori sayfası - altın takı ve mücevher ürünleri. Güvenli alışveriş, uygun fiyatlar.';
    };
    
    const getCategoryKeywords = () => {
        if (currentCategory) {
            return `${currentCategory.baslik}, ${currentCategory.baslik.toLowerCase()}, ${currentCategory.baslik.toLowerCase()} satışı, ikinci el ${currentCategory.baslik.toLowerCase()}, BiKuyum, altın satışı, mücevher satışı`;
        }
        return 'altın takı, mücevher, kategoriler, BiKuyum, online alışveriş, kuyumcu, pırlanta, değerli taş, yatırım, altın al, mücevher al, güvenilir altın, güvenilir takı, güvenilir pırlanta, gümüş takı, rose gold, beyaz altın, sarı altın, 14 ayar, 18 ayar, 22 ayar, gram altın, çeyrek altın, yarım altın, tam altın, cumhuriyet altını, ata altını, bilezik, kolye, küpe, yüzük, set takı, düğün takısı, nişan takısı, beşiktaş, alyans, çocuk takısı, erkek takısı, kadın takısı, tektaş yüzük, solitaire, pırlanta küpe, pırlanta kolye, zümrüt, safir, yakut, inci, doğal taş, el yapımı, özel tasarım, modern takı, klasik takı, vintage takı, antika takı, takı bakımı, altın fiyatları, pırlanta fiyatları, takı taksit, ücretsiz kargo, hızlı teslimat, güvenli ödeme, sertifikalı takı, garantili takı, takı değişimi, takı tamiri, kişiye özel, hediye takı, sevgiliye hediye, anneye hediye, eşe hediye, doğum günü hediyesi, yıldönümü hediyesi, mezuniyet hediyesi, marka takı, lüks takı, premium takı, kaliteli takı, işçilik, takı koleksiyonu, sezon takı, trend takı, günlük takı, özel gün takısı, nikah takısı, kına takısı, altın zincir, gümüş zincir, charm bilezik, pandora tarzı, minimal takı, statement takı, bohem takı, etnik takı, çiçek motifli, kalp motifli, sonsuzluk motifli, aşk takısı, şans takısı, nazarlık, muska, takı kombinleri, takı seti, komple takı, avantajlı fiyat, kampanya, indirim, fırsat ürünleri, yeni sezon, en çok satan, popüler takı, beğenilen takı, önerilen takı, takı danışmanlığı, uzman kuyumcu, usta işi, el emeği, özenle seçilmiş, özel koleksiyon, sınırlı sayıda, nadir bulunan, değer kazanan, yatırım amaçlı, altın gram hesaplama, pırlanta karat, taş kalitesi, renk taşı, berrak taş, parlak taş, ışıltılı takı, göz alıcı, şık takı, zarif takı, asil takı, prestijli takı, statü takı, imaj takı, güven veren, kalite garantisi, yaşam boyu garanti, değişim garantisi, para iade garantisi, müşteri memnuniyeti';
    };

    const isFavorite = (product) => {
        return favorites.some(favProduct =>
            String(favProduct.urun_id) === String(product.id)
        );
    };

    const handleFavoriteToggle = async (event, product) => {
        event.stopPropagation();
        event.preventDefault();

        try {
            if (isFavorite(product)) {
                const favoriteProduct = favorites.find(fav =>
                    String(fav.urun_id) === String(product.id)
                );
                if (favoriteProduct) {
                    await removeFavorite(favoriteProduct);
                }
            } else {
                await addToFavorite(product);
            }
        } catch (error) {
            console.error('Favori işlemi sırasında hata:', error);
        }

        // Olayın daha fazla yayılmasını engelle
        if (event.nativeEvent) {
            event.nativeEvent.stopImmediatePropagation();
        }

        return false;
    };
    useEffect(() => {
        loadFavorites();
    }, []);

    useEffect(() => {
        if (id) {
            fetchCategoryProducts(id, state.currentPage, sort)
                .catch(err => {
                    setShouldRedirectTo404(true);
                });
        }
    }, []);

    const handleScroll = useCallback(_.throttle(() => {
        const scrollThreshold = window.innerWidth < 768 ? 1400 : 700;
        if (loading || !hasMore) return;

        if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - scrollThreshold) {
            fetchCategoryProducts(id, state.currentPage, sort);
        }
    }, 500), [loading, hasMore, id, fetchCategoryProducts, state.currentPage, sort]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    const handleSortChangeWithRedirect = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === "price_asc") {
            navigate(`?sort=price_asc`);
            window.location.reload();
        } else if (selectedValue === "price_desc") {
            navigate(`?sort=price_desc`);
            window.location.reload();
        } else {
            navigate(`?sort=newest`);
            window.location.reload();
        }
    };

    if (shouldRedirectTo404 || error) {
        return <Navigate to="/404" />;
    }

    if (loading) return <Loader />;

    return (
        <>
            <Helmet>
                <title>{getCategoryTitle()}</title>
                
                {/* Meta Description */}
                <meta name="description" content={getCategoryDescription()} />
                
                {/* Meta Keywords */}
                <meta name="keywords" content={getCategoryKeywords()} />
                
                {/* Robots Meta */}
                <meta name="robots" content="index, follow, max-image-preview:large" />
                
                {/* Open Graph Meta Etiketleri */}
                <meta property="og:title" content={getCategoryTitle()} />
                <meta property="og:description" content={getCategoryDescription()} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:site_name" content="BiKuyum" />
                <meta property="og:locale" content="tr_TR" />
                
                {/* Twitter Card Meta Etiketleri */}
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content={getCategoryTitle()} />
                <meta name="twitter:description" content={getCategoryDescription()} />
                
                {/* Canonical URL */}
                <link rel="canonical" href={window.location.href} />
                
                {/* JSON-LD Yapılandırılmış Veri */}
                {currentCategory && (
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org/",
                            "@type": "CollectionPage",
                            "name": currentCategory.baslik,
                            "description": getCategoryDescription(),
                            "url": window.location.href,
                            "mainEntity": {
                                "@type": "ItemList",
                                "numberOfItems": filteredProducts.length,
                                "itemListElement": filteredProducts.slice(0, 10).map((product, index) => ({
                                    "@type": "ListItem",
                                    "position": index + 1,
                                    "item": {
                                        "@type": "Product",
                                        "name": product.baslik,
                                        "url": `${window.location.origin}/urun/${product.sef}`,
                                        "image": getImageUrl(product.image.i1),
                                        "offers": {
                                            "@type": "Offer",
                                            "price": product.fiyat,
                                            "priceCurrency": "TRY",
                                            "availability": product.stok > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                                        }
                                    }
                                }))
                            },
                            "breadcrumb": {
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                    {
                                        "@type": "ListItem",
                                        "position": 1,
                                        "name": "Ana Sayfa",
                                        "item": window.location.origin
                                    },
                                    {
                                        "@type": "ListItem",
                                        "position": 2,
                                        "name": currentCategory.baslik,
                                        "item": window.location.href
                                    }
                                ]
                            }
                        })}
                    </script>
                )}
            </Helmet>
            <div className='categories-container-mobile d-flex flex-column-reverse p-0'>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='d-md-none d-block'>
                        <Sidebar />
                    </div>
                    <div className="sort-dropdown-mobile ms-auto mt-md-3 mt-0 mb-0">
                        <select
                            id="sortOrderMobile"
                            className="form-select form-select-sm"
                            value={sort}
                            onChange={handleSortChangeWithRedirect}
                        >
                            <option value="random">Filtrele</option>
                            <option value="newest">En Yeni</option>
                            <option value="price_asc">Artan Fiyat</option>
                            <option value="price_desc">Azalan Fiyat</option>
                        </select>
                    </div>
                </div>
                <div className='categories-list d-none'>
                    <div className='categories-filter'>
                        <label>Fiyat</label>
                        <div className='price-inputs'>
                            <input
                                type="number"
                                placeholder='En Az'
                                value={minPrice}
                                onChange={handleMinPriceChange}
                            />
                            <input
                                type="number"
                                placeholder='En Çok'
                                value={maxPrice}
                                onChange={handleMaxPriceChange}
                            />
                            <FaSearch className="search-icon" onClick={filterByPrice} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='categories-container'>
                <div className='categories-list d-md-block d-none'>
                    <Sidebar />
                    <div className='categories-filter d-none'>
                        <label>Fiyat</label>
                        <div className='price-inputs'>
                            <input
                                type="number"
                                placeholder='En Az'
                                value={minPrice}
                                onChange={handleMinPriceChange}
                            />
                            <input
                                type="number"
                                placeholder='En Çok'
                                value={maxPrice}
                                onChange={handleMaxPriceChange}
                            />
                            <FaSearch className="search-icon" onClick={filterByPrice} />
                        </div>
                    </div>
                </div>

                <div className="categories-product gap-3">
                    {filteredProducts.map(product => (
                        <ProductCard
                            key={`${product.id}`}
                            product={product}
                            isFavorite={isFavorite}
                            onFavoriteToggle={handleFavoriteToggle}
                            showGramPrice={true}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default CategoriesProduct;